import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Caret from '../Caret'
import styles from './SelectButton.module.scss'


class SelectButton extends React.Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = { value: ''} ;
  }

  handleClick = () => {
    (this.props.isSearchable && !this.props.isOpen) && this.textInput.current.focus();
    (this.props.isSearchable && this.props.isOpen) && this.textInput.current.blur();
    this.props.handleClick && this.props.handleClick();
  }

  handleBlur = (e) => {
    setTimeout(() => this.textInput.current.value = '', 100);
  }

  handleFocus = () => {
    this.props.onSearch && this.props.onSearch('');
  }

  handleChange = (e) => {
    let val = e.target.value;

    if (val) {
      // trim the value if it's starting with a space
      if (val.substring(0, 1) === ' ') {
        val = val.trim();
      }
    }

    this.setState({ value: val });
    this.props.onSearch && this.props.onSearch(val);
  }

  render () {
    const { buttonAlign, caret, className, design, disable, isOpen, isSearchable, size, title } = this.props;
    const showSearch = isSearchable && !disable;

    return (
      <div className={classNames(styles.container, { [styles.small]: size === 'small' })}>
        <div className={classNames(styles.button, className, {
          [styles.rightAlign]: buttonAlign === 'right',
          [styles.filter]: design === 'filter',
          [styles.disableButton]: disable
          })} onClick={this.handleClick}>
          {showSearch && <input ref={this.textInput} className={classNames({ [styles.hasValue]: this.props.value })} type="text" placeholder={title} onChange={this.handleChange} onBlur={(e) => this.handleBlur(e)} onFocus={this.handleFocus} />}
          {!showSearch && <div className={classNames(styles.text, { [styles.placeholder]: !this.props.value, [styles.disableText]: disable })}>{title}</div>}
          {(caret && !disable) && <span className={classNames(styles.caret, { [styles.open]: isOpen })}><Caret isOpen={isOpen}/></span>}
        </div>
      </div>
      
    )
  }
}
SelectButton.propTypes = {
  /** Class name of the input, for custom designs */
  className: PropTypes.string,
  /** FormButton title */
  title: PropTypes.string,
  /** Design Style */
  design: PropTypes.oneOf(['filter', 'standard', 'default']),
  /** Props for Datepicker */
  onClick: PropTypes.func,
  disable: PropTypes.bool,
  value: PropTypes.string,
  /** Alignment of text within select button */
  buttonAlign: PropTypes.oneOf(['left', 'right']),
  /* Size of table: font, row height */
  size: PropTypes.oneOf(['small', 'default']),
  /** Search select options (Ony available for single select) */
  isSearchable: PropTypes.bool,
}

SelectButton.defaultProps = {
  buttonAlign: 'left',
  isSearchable: false
}

export default SelectButton
